import MOCKED_ADDRESS_LIST from "./addresses/address_list";

export const MOCKED_ADDRESSES_STATE = {
  addresses: MOCKED_ADDRESS_LIST,
  newAddress: {},
  currentAddress: {}
};
